<template>
  <Uploader v-model="fileList" :max-count="1" accept="image/*" v-bind="$attrs">
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
      <slot v-if="_" :name="name" v-bind="slotData" />
    </template>
  </Uploader>
</template>

<script lang="ts" setup>
import Uploader from "@/components/Uploader.vue";

const fileList = defineModel<{ url: string }[]>({ default: [] });
</script>
